export const actionLoadingStates = {
  idle: "idle",
  pending: "pending",
  succeeded: "succeeded",
  failed: "failed",
} as const;

export type ActionLoadingState =
  (typeof actionLoadingStates)[keyof typeof actionLoadingStates];

export const asyncThunkRequestStatuses = {
  idle: "idle",
  pending: "pending",
  fulfilled: "fulfilled",
  rejected: "rejected",
} as const;

export type AsyncThunkRequestStatus =
  (typeof asyncThunkRequestStatuses)[keyof typeof asyncThunkRequestStatuses];

export const alertTypes = {
  information: "information",
  success: "success",
  error: "error",
} as const;

export type AlertType = (typeof alertTypes)[keyof typeof alertTypes];

export const jobStatuses = {
  information: ["queued", "running", "scheduled"],
  success: "succeeded",
  error: ["retrying", "discarded"],
} as const;

export const errorTypes = {
  validation_error: "validation_error",
  job_concurrency_error: "job_concurrency_error",
  standard_error: "standard_error",
} as const;

export type ErrorType = (typeof errorTypes)[keyof typeof errorTypes];
